import { Injectable } from "@angular/core";
import { AppConfig } from './app.config.services';
import { Observable, Subject } from "rxjs";
import { ActionEvent, IMilestoneSummaryEventInfo, StatusEvent } from "../interfaces/Logs.interface";
import { log } from "../utils/logging";
import { LogUpload } from "../utils/log-upload";
import { IHierarchy, ISupervisorHierarchy } from "../interfaces/agent.interface";

@Injectable()
export class TrsEventsService {
  public isLoggedIn: boolean = false;
  public supervisorId: string;
  public supervisorProfilePicture: string;
  public supervisorAvayaLoginId: string;
  public supervisorOrgHierarchy: IHierarchy | null = null;
  public clientName: string | null;
  public AgentTime: any;
  public Hierarchy: ISupervisorHierarchy[];
  public selectedAgentId: string;
  public iamToken: string;
  public iamUIAPISession: string;
  public iamSessionIntervalCheck: NodeJS.Timeout;
  public JwtAuthenticationToken: string = "";
  public JwtRefreshToken: string = "";

  public selectedAgentAvayaId: string;
  public events: { [key: string]: any[] } = {};
  public TeamId: number = 0;

  public evtdata: Subject<any> = new Subject();
  public evtDataObservable: Observable<any> = this.evtdata.asObservable();

  traceId: string;
  logUploader: LogUpload = new LogUpload("TrsEventsService");

  UploadMilestoneSummary = async (info: IMilestoneSummaryEventInfo): Promise<boolean> => {
    const baseURL: string | null = AppConfig.GetServerBaseURL();
    if (baseURL != null && baseURL != '') {
      const headers: Headers = new Headers();
      headers.append("Content-Type", "application/json");

      const url: string = `${baseURL}api/uploadlogtodb?Type=trs_milestones_summary`;

      try {
        const apiResponse: Response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(info) });
        log.info(`Status of uploading milestone summary for id ${info.Info.SummaryId}`, apiResponse);
        this.logUploader.info("UploadMilestoneSummary", `Status of uploading milestone summary for id ${info.Info.SummaryId}: ${apiResponse.status}`);
        return true;
      }
      catch (error) {
        log.error(`Unable to upload milestone summary for id ${info.Info.SummaryId}`, error);
        this.logUploader.error("UploadMilestoneSummary", `Unable to upload milestone summary for id ${info.Info.SummaryId}`, error)
        return false;
      }
    }
    else {
      log.error(`TRSServerURL is not configured`, null);
      return false;
    }
  }

  UploadMilestoneAction = async (info: ActionEvent): Promise<boolean> => {
    const baseURL: string | null = AppConfig.GetServerBaseURL();
    if (baseURL != null && baseURL != '') {
      const headers: Headers = new Headers();
      headers.append("Content-Type", "application/json");

      const url: string = `${baseURL}api/uploadlogtodb?Type=trs_milestones_actions`;

      try {
        const apiResponse: Response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(info) });
        log.info(`Status of uploading milestone action (${info.Action}) for id ${info.SummaryId}`, apiResponse);
        this.logUploader.info("UploadMilestoneAction", `Status of uploading milestone action for id ${info.SummaryId}: ${apiResponse.status}`);
        return true;
      }
      catch (error) {
        log.error(`Unable to upload milestone action (${info.Action}) for id ${info.SummaryId}`, error);
        this.logUploader.error("UploadMilestoneAction", `Unable to upload milestone action for id ${info.SummaryId}`, error)
        return false;
      }
    }
    else {
      log.error(`TRSServerURL is not configured`, null);
      return false;
    }
  }

  UploadMilestoneStatus = async (info: StatusEvent): Promise<boolean> => {
    const baseURL: string | null = AppConfig.GetServerBaseURL();
    if (baseURL != null && baseURL != '') {
      const headers: Headers = new Headers();
      headers.append("Content-Type", "application/json");

      const url: string = `${baseURL}api/uploadlogtodb?Type=trs_milestones_status`;

      try {
        const apiResponse: Response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(info) });
        log.info(`Status of uploading milestone status (${info.Status}) for id ${info.SummaryId}`, apiResponse);
        this.logUploader.info("UploadMilestoneStatus", `Status of uploading milestone status for id ${info.SummaryId}: ${apiResponse.status}`);
        return true;
      }
      catch (error) {
        log.error(`Unable to upload milestone status (${info.Status}) for id ${info.SummaryId}`, error);
        this.logUploader.error("UploadMilestoneStatus", `Unable to upload milestone status for id ${info.SummaryId}`, error)
        return false;
      }
    }
    else {
      log.error(`TRSServerURL is not configured`, null);
      return false;
    }
  }
}